import {deviceTypeConstants} from "../constants/device-type-constants";

const initState = {
    deviceTypeList: null,
    dropdown: null
};

export function deviceTypeReducer(state = initState, action) {
    switch (action.type) {
        case deviceTypeConstants.DEVICE_TYPE_DROPDOWN_SUCCESS:
            return {
                ...state,
                dropdown: action.dropdown
            };
        case deviceTypeConstants.DEVICE_TYPE_LIST_SUCCESS:
            return  {
                ...state,
                deviceTypeList: action.deviceTypeModel
            };
        case deviceTypeConstants.DEVICE_TYPE_LIST_CLEAR:
            return {
                ...state,
                deviceTypeList: null
            };
        default:
            return state
    }
}

